import { OrderDelivery } from '@restaurant/api';
import moment from 'moment';
import { OrderDeliveryFormValues } from './types';

export const transformToDeliveryFormValues = (
  data: OrderDelivery
): OrderDeliveryFormValues => {
  const { date, time } = data?.deliveryDateTime ?? {};
  return {
    ...data,
    deliveryDateTime: {
      date: date ? moment(date, 'YYYY-MM-DD') : null,
      time: time ? moment(time, 'HH:mm') : null,
    },
  };
};

export const transformFromDeliveryFormValues = (
  values: OrderDeliveryFormValues
) => {
  const { deliveryDateTime, ...rest } = values;

  return {
    ...rest,
    mobileCountryCode: '+62',
    deliveryDateTime: {
      date: deliveryDateTime.date?.format?.('YYYY-MM-DD') ?? '',
      time: deliveryDateTime.time?.format?.('HH:mm') ?? null,
    },
  };
};
